import * as utilCommon from 'helpers/util-common';
import { MembershipTypes } from '../../members.model';
import * as _funMemberCommitteeDetails from '../member-committee-details/function';
import { committeeDesignationCodes, committeeMemberStatusEnum, committeeStatusEnum, memberCommitteeStatusEnum } from '../../../../../models/common.models';
import { touch } from 'redux-form';

let self = {};
let accountNo = '';
let updateBasicDetailsEvent = {};
let updatedDetailsForupdateMemberCommitteeBasicDetails = {};
let studentMembershipId = 17;
let isOfficerUpdated = false;
const SELECT_VALUE = 'select';

export const setClassInstance = (instance) => {
    self = instance;
    const membershipTypeId = self.props.initialValues.MemberTypeId ? self.props.initialValues.MemberTypeId : self.props.initialValues.memberDetails.MemberTypeId;
    accountNo = self.props.AccountNumber;
    self.props.change('CommitteeJoinDate', self.state.committeeJoinDate);
    self.props.change('InactiveReason', self.state.inactiveReasonSelectedValue);
    self.props.change('InactiveDate', self.state.inactiveCommitteeDate);
    self.props.change('OfficerTitle', self.state.officerTitleSelectedValue);
    self.props.change('OfficerAppointedDate', self.state.officerAppointedDate);
    self.props.change('Status', self.state.memberCommitteeStatus);
    self.props.change('HonoraryStatus', self.props.memberCommitteeDetails.TopSection.HonoraryStatus === true ? 'yes' : 'no');
    self.props.change('CommitteePayStatus', self.props.memberCommitteeDetails.TopSection.CommitteePayStatus === true ? 'yes' : 'no');

    self.props.getActiveFeeGroupList((response) => {
        self.setState({ feeGroupList: formatFeeGroupList(response || []) }
        );
        if (self.props.flagFeature.StudentCommitteeManagement && membershipTypeId === studentMembershipId) {
            self.setState({ disableFieldForStudent: true });
        }
    });
}

export const handleChangeCommitteeJoinDate = (event, value) => {
    self.setState({ committeeJoinDate: value })
}
export const handleChangeOfficerAppointedDate = (event, value) => {
    self.setState({ officerAppointedDate: value });
    if (!value) {
        self.props.change('OfficerAppointedDate', '')
    }
}
export const handleChangeMemberCommitteeStatus = (event, value) => {
    let memberCommitteeStatus = event.currentTarget.querySelector('input').value;
    self.setState({ memberCommitteeStatus })

    if (memberCommitteeStatus == memberCommitteeStatusEnum.INACTIVE) {
        self.props.change('OfficerTitle', '')
        self.props.change('OfficerAppointedDate', self.props.memberCommitteeDetails.OfficerAppointedDate)
        self.props.change('CommitteeJoinDate', self.props.memberCommitteeDetails.CommitteeJoinDate)
        self.props.change('InactiveDate', self.props.memberCommitteeDetails?.TopSection?.MemberCommitteeStatus?.toLowerCase() === 'active' ? utilCommon.formatDateToMMDDYYYY() : self.props.memberCommitteeDetails.InactiveDate)
        self.setState({
            officerTitleSelectedValue: '',
            officerAppointedDate: self.props.memberCommitteeDetails.OfficerAppointedDate,
            committeeJoinDate: self.props.memberCommitteeDetails.CommitteeJoinDate,
            inactiveCommitteeDate: self.props.memberCommitteeDetails?.TopSection?.MemberCommitteeStatus?.toLowerCase() === 'active' ? utilCommon.formatDateToMMDDYYYY() : self.props.memberCommitteeDetails.InactiveDate
        })

        if (self.props.memberCommitteeDetails.TopSection.OfficerTitleId > 0) {
            const oldOfficer = self.props.memberCommitteeDetails?.TopSection?.OfficerTitleName;
            const oldOfficerAppointedDate = utilCommon.formatDateToMMDDYYYY(self.props.memberCommitteeDetails?.TopSection?.OfficerAppointedDate);
            self.props.change('PreviousOfficerAppointedDate', oldOfficerAppointedDate)
            self.props.change('PreviousOfficerEndDate', utilCommon.formatDateToMMDDYYYY())
            self.setState({
                isShowPreviousOfficer: true,
                previousOfficerTitle: oldOfficer,
                previousOfficerJoinedDate: oldOfficerAppointedDate,
                previousOfficerEndDate: utilCommon.formatDateToMMDDYYYY()
            });
        }
    }
}
export const handleChangeCommitteeInactiveDate = (event, value) => {
    self.props.dispatch((touch(self.props.form, 'InactiveDate')));
    self.setState({ inactiveCommitteeDate: value })
}
export const handleChangeInactiveReason = (event, value) => {
    self.setState({ inactiveReasonSelectedValue: value })
}
export const handleChangeofficerTitle = (event, value) => {
    self.setState({ officerTitleSelectedValue: value })
}
export const popUpCancel = () => {
    self.setState({ isCommitteeJoinDateGreaterThanClassificationDate: false, isCommitteeJoinDateGreaterThanVoteDate: false, isCommitteeJoinDateGreaterThanBothDates: false });
}
export const cancelAdministrativeAssistantOrStaffManagerPopup = () => {
    self.setState({ isShowAdministrativeAssistantOrStaffManagerPopup: false });
}
export const popUpConfirm = (event, value) => {
    self.setState({ isCommitteeJoinDateGreaterThanClassificationDate: false, isCommitteeJoinDateGreaterThanVoteDate: false, isCommitteeJoinDateGreaterThanBothDates: false });
    updateMemberCommitteeBasicDetails(updateBasicDetailsEvent.event, updateBasicDetailsEvent.value);
}
export const confirmAdministrativeAssistantOrStaffManagerPopup = (event, value) => {
    self.setState({ isShowAdministrativeAssistantOrStaffManagerPopup: false });

    // Updating Member Committee Basic Details
    self.props.updateMemberCommitteeBasicDetails(updatedDetailsForupdateMemberCommitteeBasicDetails, (response = false) => {
        _funMemberCommitteeDetails.getMemberMainSubCommittees(self.props.activeCommitteeId);
        self.props.getMemberDetails(accountNo);

        if (response) {
            self.setState({ isShowAdministrativeAssistantPopup: true });
        } else {
            self.props.onEditCancel();
        }
    });
}
export const updateBasicDetails = (event, value) => {
    updateBasicDetailsEvent = { event, value }
    const { CommitteeJoinDate } = event
    const { memberCommitteeDetails: { GeneralInformation: { ClassificationDate, VoteDate } } } = self.props
    let isCommitteeJoinDateGreaterThanClassificationDate = utilCommon.compareDates(utilCommon.formatDateToMMDDYYYY(CommitteeJoinDate), utilCommon.formatDateToMMDDYYYY(ClassificationDate), true, 'MM/dd/yyyy');
    let isCommitteeJoinDateGreaterThanVoteDate = utilCommon.compareDates(utilCommon.formatDateToMMDDYYYY(CommitteeJoinDate), utilCommon.formatDateToMMDDYYYY(VoteDate), true, 'MM/dd/yyyy');
    let isCommitteeJoinDateGreaterThanBothDates = (isCommitteeJoinDateGreaterThanClassificationDate && isCommitteeJoinDateGreaterThanVoteDate)
    isCommitteeJoinDateGreaterThanClassificationDate && self.setState({ isCommitteeJoinDateGreaterThanClassificationDate });
    isCommitteeJoinDateGreaterThanVoteDate && self.setState({ isCommitteeJoinDateGreaterThanVoteDate });
    isCommitteeJoinDateGreaterThanBothDates && self.setState({ isCommitteeJoinDateGreaterThanBothDates });
    (!isCommitteeJoinDateGreaterThanClassificationDate && !isCommitteeJoinDateGreaterThanVoteDate && !isCommitteeJoinDateGreaterThanBothDates) && updateMemberCommitteeBasicDetails(event, value);
}
export const updateMemberCommitteeBasicDetails = (event, value) => {
    const { CommitteeJoinDate, Status, OfficerTitle, InactiveReason, OfficerAppointedDate, ReasonforUpdate, FeeGroupId, HonoraryStatus, CommitteePayStatus, PreviousOfficerEndDate, PreviousOfficerAppointedDate } = event
    const { committeeJoinDate, memberCommitteeStatus, officerTitleSelectedValue, inactiveReasonSelectedValue, officerAppointedDate } = self.prevState;
    const { activeCommitteeId, MemberId, AccountNumber, initialValues: { CommitteeDesignation }, memberCommitteeInfo } = self.props
    var CommitteeDesignations = memberCommitteeInfo.filter(x => x.CommitteeId == activeCommitteeId)[0].CommitteeDesignation;
    self.setState({
        committeeName: CommitteeDesignations && CommitteeDesignations.split('.')[0]
    });
    let officersList = self.state.officerTitle;
    const updatedDetails = {
        AccountNumber: AccountNumber,
        CommitteeId: activeCommitteeId,
        MemberId: MemberId,
        JoinAsMemberDate: CommitteeJoinDate,
        MemberCommitteeStatus: Status == 'active' ? 1 : 0,
        InactiveReasonId: InactiveReason == 'select' || Status == 'active' ? 0 : InactiveReason,
        OfficerTitleId: OfficerTitle == 'select' ? 0 : OfficerTitle,
        OfficerAppointedDate: OfficerAppointedDate ? OfficerAppointedDate : '',
        ReasonForUpdate: ReasonforUpdate,
        Officers: (officersList && officersList.length > 0 ? officersList.filter((x, index) => { return index > 0 }) : null),
        FeeGroupId: self.state.committeePayStatus === 'yes' ? FeeGroupId : 0,
        HonoraryStatus: self.state.honoraryStatus === 'yes',
        CommitteePayStatus: self.state.committeePayStatus === 'yes',
        OfficerTitle: (officersList && officersList.length > 0 && OfficerTitle != 'select' && OfficerTitle != '' ? officersList.filter(x => x.OfficerTitleId == OfficerTitle)[0].OfficerTitleName : ''), 
        OfficerTitleSelectedValue: (officersList && officersList.length > 0 && officerTitleSelectedValue != 'select' && officerTitleSelectedValue != '' ? officersList.filter(x => x.OfficerTitleId == officerTitleSelectedValue)[0].OfficerTitleName : ''),
        CommitteeDesignation: (CommitteeDesignations && CommitteeDesignations.split('.')[0] ? CommitteeDesignations.split('.')[0] : CommitteeDesignations),
        SubCommitteeDesignation: [(CommitteeDesignations && CommitteeDesignations.split('.')[0] ? CommitteeDesignations : '')],
        InactiveDate: self.state.inactiveCommitteeDate,
        OfficerEndDate: PreviousOfficerEndDate ?? null,
        IsOfficerHistoryArchive: self?.state?.isArchieveOfficerDetail ?? null,
        PreviousOfficerAppointedDate: PreviousOfficerAppointedDate ?? null
    }
    let honoraryNomessage = (updatedDetails.CommitteePayStatus === self.props.memberCommitteeDetails.TopSection.CommitteePayStatus && updatedDetails.HonoraryStatus === self.props.memberCommitteeDetails.TopSection.HonoraryStatus && (updatedDetails.FeeGroupId || '').toString() === (self.props.memberCommitteeDetails.TopSection.FeeGroupId || '').toString())
    if ((CommitteeJoinDate == committeeJoinDate && Status == memberCommitteeStatus && OfficerTitle == officerTitleSelectedValue) && ((honoraryNomessage && self.props.MemberTypeId !== MembershipTypes.Student) || (self.props.MemberTypeId === MembershipTypes.Student))) {
        if (Status == 'inactive') {
            if (InactiveReason == inactiveReasonSelectedValue) {
                self.props.displayNoChangesMadeMessage()
            } else {

                if ((self.state.officerTitleSelectedValue === 7 || self.state.officerTitleSelectedValue === 6) && CommitteeDesignations.indexOf('.') > -1) {
                    self.setState({ isShowAdministrativeAssistantOrStaffManagerPopup: true });
                    updatedDetailsForupdateMemberCommitteeBasicDetails = updatedDetails;

                } else {
                    // Updating Member Committee Basic Details
                    self.props.updateMemberCommitteeBasicDetails(updatedDetails, (response = false) => {
                        if (response) {
                            self.setState({ isShowAdministrativeAssistantPopup: true });
                        }
                        return _funMemberCommitteeDetails.getMemberMainSubCommittees(activeCommitteeId)
                    });
                }

            }
        } else if (Status == 'active' && OfficerTitle != 'select') {
            if (OfficerAppointedDate == officerAppointedDate) {
                self.props.displayNoChangesMadeMessage()
            } else {

                if ((self.state.officerTitleSelectedValue === 7 || self.state.officerTitleSelectedValue === 6) && CommitteeDesignations.indexOf('.') > -1) {
                    self.setState({ isShowAdministrativeAssistantOrStaffManagerPopup: true });
                    updatedDetailsForupdateMemberCommitteeBasicDetails = updatedDetails;

                } else {
                    // Updating Member Committee Basic Details
                    self.props.updateMemberCommitteeBasicDetails(updatedDetails, (response = false) => {
                        if (response) {
                            self.setState({ isShowAdministrativeAssistantPopup: true });
                        }

                        return _funMemberCommitteeDetails.getMemberMainSubCommittees(activeCommitteeId)
                    });
                }

            }
        } else {
            self.props.displayNoChangesMadeMessage()
        }

        self.props.onEditCancel();
    } else {
        if ((self.state.officerTitleSelectedValue === 7 || self.state.officerTitleSelectedValue === 6) && CommitteeDesignations.indexOf('.') > -1) {
            self.setState({ isShowAdministrativeAssistantOrStaffManagerPopup: true });
            updatedDetailsForupdateMemberCommitteeBasicDetails = updatedDetails;

        } else {
            // Updating Member Committee Basic Details
            self.props.updateMemberCommitteeBasicDetails(updatedDetails, (response = false) => {
                _funMemberCommitteeDetails.getMemberMainSubCommittees(activeCommitteeId);
                self.props.getMemberDetails(accountNo);

                if (response) {
                    self.setState({ isShowAdministrativeAssistantPopup: true });
                } else {
                    self.props.onEditCancel();
                }
            });
        }

    }
}

// Get Committee join date
const getCommitteeJoinDateHandler = (data, committeeId) => {
    if (!Array.isArray(data) || data.length === 0) return null;
    const activeCommittee = data.filter((e) => Number(e?.CommitteeId) === Number(committeeId));
    return activeCommittee?.[0]?.CommitteeJoinDate ? new Date(activeCommittee[0].CommitteeJoinDate) : null
}

// Get Committee Inactive date
const getCommitteeInactiveDateHandler = (data, committeeLength) => {
    if (!data || !data.length > 0) return null;
    const activeCommittee = data.filter((e) => e?.CommitteeDesignation.split(".").length === committeeLength);
    return activeCommittee?.[0]?.InactiveDate ? new Date(activeCommittee[0].InactiveDate) : null
}

export const validateHandler = (values, props) => {
    const errors = {};
    const { CommitteeJoinDate, ArchivePreviousOfficer } = values;
    const { ReactivatedOnCommitteeDate } = props?.memberCommitteeDetails;
    let maxJoinDate = CommitteeJoinDate;
    if (ReactivatedOnCommitteeDate && utilCommon.compareDates(ReactivatedOnCommitteeDate, CommitteeJoinDate)) {
        maxJoinDate = ReactivatedOnCommitteeDate;
    }
    const memberCommitteeStatus = self.props?.memberCommitteeDetails?.TopSection?.MemberCommitteeStatus?.toLowerCase() ?? null;
    if (!values.CommitteeJoinDate) {
        errors.CommitteeJoinDate = utilCommon.getMessage(props.messageCodes, '8130.text');
    } else if (values.CommitteeJoinDate && (!utilCommon.compareDates(utilCommon.formatDateToMMDDYYYY(values.CommitteeJoinDate), utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true, 'MM/dd/yyyy'))) {
        errors.CommitteeJoinDate = utilCommon.getMessage(props.messageCodes, '4021.text');
    }

    if (values.Status == memberCommitteeStatusEnum.INACTIVE) {
        if (values.InactiveReason == 'select' || !values.InactiveReason) {
            errors.InactiveReason = utilCommon.getMessage(props.messageCodes, '8131.text');
        }
        if (!values.InactiveDate || values.InactiveDate.trim() == '') {
            errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8174.text');
        }
        if(values?.InactiveDate && memberCommitteeStatus) {
            const inputDate = new Date(values.InactiveDate).setHours(0, 0, 0, 0);
            const currentDate = new Date().setHours(0, 0, 0, 0);
            if(memberCommitteeStatus === memberCommitteeStatusEnum.ACTIVE) {
                //If user enters the future Inactive date
                if(inputDate > currentDate) {
                    errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8173.text');
                }

                if (props?.latestCommitteeJoinDate?.CommitteeJoinDate) {
                    const latestCommitteeJoinDate = new Date(props?.latestCommitteeJoinDate?.CommitteeJoinDate).setHours(0, 0, 0, 0);
                    if(inputDate < latestCommitteeJoinDate) {
                        const committeeDesignation = props?.latestCommitteeJoinDate?.CommitteeDesignation;
                        const committeeDesignationLength = committeeDesignation.split(".").length;
                        errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8175.text') + ` ${committeeDesignationCodes[committeeDesignationLength]} ${committeeDesignation} Committee Join Date/Reactivated Date.`;
                    }
                }

                // Inactive Date less then Officer End Date
                if (values?.PreviousOfficerEndDate && inputDate < new Date(values.PreviousOfficerEndDate).setHours(0, 0, 0, 0)) {
                    errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8187.text');
                }
            }
            if(memberCommitteeStatus === memberCommitteeStatusEnum.INACTIVE && Array.isArray(props.latestCommitteeJoinDate)) {
                const committeeDesignation = props?.latestCommitteeJoinDate?.filter((e) => Number(e?.CommitteeId) === Number(self.state.activeCommitteeId));
                const committeeDesignationLength = committeeDesignation[0]?.CommitteeDesignation.split(".").length;
                const committeeJoinDate = getCommitteeJoinDateHandler(props?.latestCommitteeJoinDate, self.state.activeCommitteeId);

                // A: If the user selects the Inactive date less than the Committee Join Date/Reactivated Date
                if (inputDate < committeeJoinDate) {
                    errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8176.text');   
                }

                // B: If the user selects the Inactive date on sub committee which is after the main committee inactive date
                if (committeeDesignationLength === 2) {
                    const committeeInactiveDate = getCommitteeInactiveDateHandler(props?.latestCommitteeJoinDate, 1);
                    if(committeeInactiveDate && inputDate > committeeInactiveDate) {
                        errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8177.text'); 
                    }
                }

                // C: If the user selects the Inactive date on the section committee, which is after the subcommittee inactive date
                if (committeeDesignationLength === 3) {
                    const committeeInactiveDate = getCommitteeInactiveDateHandler(props?.latestCommitteeJoinDate, 2);
                    if(committeeInactiveDate && inputDate > committeeInactiveDate) {
                        errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8178.text'); 
                    }
                }

                // D: If the user selects an Inactive date for a historical member, and the date is after the date when the member was marked as historical 
                if (committeeDesignation?.[0]?.MemberStatus === committeeMemberStatusEnum.HISTORICAL && inputDate > new Date(committeeDesignation?.[0]?.MemberHistoricalDate)) {
                    errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8179.text'); 
                }

                // E: If the user selects an Inactive date and the committee/subcommittee/section is inactive, and the date is after the date when the committee/subcommittee/section was marked as inactive
                if (committeeDesignation?.[0]?.CommitteeStatus === committeeStatusEnum.INACTIVE) {
                    const currentCommitteeWithInactiveDate = self.props.memberCommitteeInfo?.filter((e)=>{
                        return e?.CommitteeDesignation === committeeDesignation?.[0]?.CommitteeDesignation
                    })
                    const inactiveDate = new Date(currentCommitteeWithInactiveDate[0]?.InactiveDate).setHours(0, 0, 0, 0);
                    if (inputDate > inactiveDate) {
                        errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8180.text');
                    }
                    
                    // In case both D & E are valid, then display validation based on the earlier date.
                    if (committeeDesignation?.[0]?.MemberStatus === committeeMemberStatusEnum.HISTORICAL && inputDate > new Date(committeeDesignation?.[0]?.MemberHistoricalDate) && inputDate > inactiveDate) {
                        const date1 = new Date(committeeDesignation?.[0]?.MemberHistoricalDate).setHours(0, 0, 0, 0);
                        const date2 = inactiveDate;
                        const earliestDate = date1 < date2 ? date1 : date2;
                        if (earliestDate === date1) {
                            errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8179.text');
                        }
                        if (earliestDate === date2) {
                            errors.InactiveDate = utilCommon.getMessage(props.messageCodes, '8180.text');
                        }
                    }
                }
            }
        }
    }

    // Add Previous Officer Validation
    if (values.OfficerTitle != SELECT_VALUE && !values.OfficerAppointedDate) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3078.text');
    }    
    else if (values.OfficerTitle != SELECT_VALUE && values?.OfficerAppointedDate && !utilCommon.checkIfDateValid(values?.OfficerAppointedDate, 'MM/dd/yyyy')) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '4003.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && values?.OfficerAppointedDate && (!utilCommon.compareDates(values?.OfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true))) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '4021.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && values?.OfficerAppointedDate && (utilCommon.compareDates(values?.OfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(), true))) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3084.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && values?.OfficerAppointedDate && utilCommon.compareDates(maxJoinDate, values?.OfficerAppointedDate, true)) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8181.text');
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE)
        && !ArchivePreviousOfficer && isOfficerUpdated && !values?.PreviousOfficerAppointedDate) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3078.text');
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE)
        && isOfficerUpdated && values?.PreviousOfficerAppointedDate && !ArchivePreviousOfficer &&
        !utilCommon.checkIfDateValid(values?.PreviousOfficerAppointedDate, 'MM/dd/yyyy')) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '4003.text');
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE)
        && isOfficerUpdated && values?.PreviousOfficerAppointedDate && !ArchivePreviousOfficer &&
        !utilCommon.compareDates(values?.PreviousOfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true)) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '4021.text');
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE)
        && isOfficerUpdated && values?.PreviousOfficerAppointedDate && !ArchivePreviousOfficer &&
        utilCommon.compareDates(values?.PreviousOfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(), true)) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3084.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && !ArchivePreviousOfficer
        && isOfficerUpdated && !values?.PreviousOfficerEndDate) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '8186.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && isOfficerUpdated && values?.PreviousOfficerEndDate &&
        !ArchivePreviousOfficer && !utilCommon.checkIfDateValid(values?.PreviousOfficerEndDate, 'MM/dd/yyyy')) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '4003.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && isOfficerUpdated && values?.PreviousOfficerEndDate &&
        !ArchivePreviousOfficer && !utilCommon.compareDates(values?.PreviousOfficerEndDate, utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true)) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '4021.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && isOfficerUpdated && values?.PreviousOfficerEndDate &&
        !ArchivePreviousOfficer && utilCommon.compareDates(values?.PreviousOfficerEndDate, utilCommon.formatDateToMMDDYYYY(), true)) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '8185.text');
    }
    else if (values.OfficerTitle != SELECT_VALUE && values?.OfficerAppointedDate &&
        values?.PreviousOfficerEndDate &&
        !utilCommon.compareDates(values?.OfficerAppointedDate, values?.PreviousOfficerEndDate)
    ) {
        errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8182.text');;
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE) &&
        utilCommon.compareDates(maxJoinDate, values?.PreviousOfficerAppointedDate, true) && !ArchivePreviousOfficer
    ) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8181.text');
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE) && values?.PreviousOfficerAppointedDate &&
        values?.PreviousOfficerEndDate && !ArchivePreviousOfficer &&
        !utilCommon.compareDates(values?.PreviousOfficerEndDate, values?.PreviousOfficerAppointedDate)
    ) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8183.text');;
    }
    else if (values.OfficerTitle != SELECT_VALUE && isOfficerUpdated && values?.OfficerAppointedDate &&
        values?.PreviousOfficerEndDate && !ArchivePreviousOfficer &&
        !utilCommon.compareDates(values?.OfficerAppointedDate, values?.PreviousOfficerEndDate)
    ) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '8174.text');;
    }
    else if ((values.OfficerTitle != SELECT_VALUE || values.OfficerTitle == SELECT_VALUE) && isOfficerUpdated && values?.PreviousOfficerAppointedDate &&
        values?.PreviousOfficerEndDate && !ArchivePreviousOfficer &&
        !utilCommon.compareDates(values?.PreviousOfficerEndDate, values?.PreviousOfficerAppointedDate)
    ) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, '8174.text');;
    }

    if (!values.ReasonforUpdate || values.ReasonforUpdate.trim() == '') {
        errors.ReasonforUpdate = utilCommon.getMessage(props.messageCodes, '8121.text');
    }
    if (!values.HonoraryStatus && props.MemberTypeId !== MembershipTypes.Student) {

        errors.HonoraryStatus = utilCommon.getMessage(props.messageCodes, '8163.text');
    } else if (values.HonoraryStatus && values.HonoraryStatus === 'yes' && !values.CommitteePayStatus && props.MemberTypeId !== MembershipTypes.Student) {
        errors.CommitteePayStatus = utilCommon.getMessage(props.messageCodes, '8164.text');

    } else if (values.CommitteePayStatus && values.CommitteePayStatus === 'yes' && (!values.FeeGroupId || parseInt(values.FeeGroupId) < 1) && props.MemberTypeId !== MembershipTypes.Student) {
        errors.FeeGroupId = utilCommon.getMessage(props.messageCodes, '8162.text');

    }
    if (!values?.PreviousOfficerAppointedDate) {
        errors.PreviousOfficerAppointedDate = utilCommon.getMessage(props.messageCodes, "8132.text");
    }
    if (!values?.PreviousOfficerEndDate) {
        errors.PreviousOfficerEndDate = utilCommon.getMessage(props.messageCodes, "8186.text");
    }
    return errors;
}
export const handelHonoraryChange = (event, value, type) => {
    let selectedValue = event.currentTarget.querySelector('input').value;
    self.props.change('FeeGroupId', '')
    switch (type) {
        case 'honorary':
            self.setState({ honoraryStatus: selectedValue, committeePayStatus: selectedValue }, () => {
                self.props.change('CommitteePayStatus', selectedValue);
            })
            break;
        case 'committeePay':
            self.setState({ committeePayStatus: selectedValue })
            break;
        default:
            // Do nothing
            break
    }

}
export const formatFeeGroupList = (list) => {
    let result = [];

    if (list && list.length > 0) {
        result = list.filter(item => item.FeeGroupTitle.toLowerCase() !== 'all').map((res) => {
            res.text = `${res.FeeGroupNumber}-${res.FeeGroupTitle}`;
            res.value = `${res.FeeGroupId}`;
            return res;
        });
        return result;
    }
    return result;
}
export const handleClickOk = (e) => {
    self.setState({ isShowAdministrativeAssistantPopup: false }, () => {
        self.props.onEditCancel();
    });
}

export const handleChangePreviousOfficerAppointedDate = (e, value) => {
    self.props.dispatch((touch(self.props.form, 'PreviousOfficerAppointedDate')));
    self.setState({ previousOfficerJoinedDate: value })
}

export const handleChangePreviousOfficerEndDate = (e, value) => {
    self.props.dispatch((touch(self.props.form, 'PreviousOfficerEndDate')));
    self.setState({ previousOfficerEndDate: value });
}

export const updatePreviousOffice = (value) => {
    isOfficerUpdated = value;
}

export const handleOnChangeArchieve = (e, value) => {
    if (value) {
        self.setState({ isShowArchievePopup: true, isArchieveOfficerDetail: false });
    }
    else {
        self.setState({ isArchieveOfficerDetail: false });
    }
}

export const closeArchievePopup = (e, value) => {
    self.setState({ isShowArchievePopup: false });
    self.props.change('ArchivePreviousOfficer', false);
}

export const handleArchieveOfficeChecked = (e, value) => {
    self.setState({ isShowArchievePopup: false, isArchieveOfficerDetail: true });
    self.props.change('ArchivePreviousOfficer', true);
}
